import React from "react";
import { useParams } from "react-router-dom";

import "../styles/booking.css";
import BookingWeek from "../components/booking/BookingWeek";

/**
 * 日程調整の公開予約ページ。
 * 中身は BookingWeek（ウィジェット内パネルと共用）に任せ、
 * ここは外枠とフッターだけを持つ。
 */
const BookingPage = () => {
  const { slug } = useParams();

  return (
    <div className="bk-page">
      <div className="bk-card">
        <BookingWeek slug={slug} />
        <footer className="bk-foot">
          Powered by <b>ノンアポ</b>
        </footer>
      </div>
    </div>
  );
};

export default BookingPage;
